import { EventName } from '@lit/react';
import { BlocksContextualMenu } from 'blocks-nextjs/blocks-web-components/components/contextual-menu/contextual-menu';
import { BlocksCloseEvent, BlocksOpenEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatContextualMenu = createComponent({
  react: React,
  tagName: 'cat-contextual-menu',
  elementClass: BlocksContextualMenu,
  events: {
    onBlContextualMenuOpen: 'bl-contextual-menu-open' as EventName<BlocksOpenEvent>,
    onBlContextualMenuClose: 'bl-contextual-menu-close' as EventName<BlocksCloseEvent>
  }
});
